var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.picture)?_c('img',{staticClass:"my-3",attrs:{"src":_vm.picture}}):_vm._e(),_c('div',{staticClass:"my-3"},[_vm._v(_vm._s(_vm.dish.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }